<template>
    <svg 
        :width="width" 
        :height="height" 
        viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16Z" :stroke="iconColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M10 7V13" :stroke="iconColor" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M7.00003 10H13" :stroke="iconColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<script>
    export default {
    props: {
        width: {
        type: [Number, String],
        default: 24,
        },
        height: {
        type: [Number, String],
        default: 24,
        },
        iconColor: {
        type: String,
        default: "currentColor",
        },
    },
    };
</script>

<style lang="scss" scoped>
    .label-list__items-remaining{
        &.label-list__items-remaining--add{
            svg{
                path{
                stroke: var(--v-link-base);
                transition: 0.3s;
                }
            }
            &:hover{
                svg{
                path{
                    stroke: var(--v-link-hover);
                }
                }
            }
        }
    }
</style>
